export default "__VITE_ASSET__gzEf_h7J__"